/* ==== Imports Módulos === */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ImageCropperModule as ImgCropperModule } from 'ngx-img-cropper';
import {
  MatButtonModule,
  MatButtonToggleModule,
  MatDialogModule,
  MatSnackBarModule,
  MatCheckboxModule
} from '@angular/material';

/* ==== Imports Components === */
import { UploadPluginComponent } from './upload.component'
import { ModalUploadPluginComponent } from './modal-upload/modal-upload.component';
import { ModalMultiuploadPluginComponent } from './modal-multi-upload/modal-multi-upload.component';
import { FormsModule } from '@angular/forms';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { environment } from 'environments/environment';
import { TranslateSharedModule } from 'app/shared/translate/translate.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSnackBarModule,
    ImageCropperModule,
    ImgCropperModule,
    AngularFireModule.initializeApp(environment.firebase, "FireMain"),
    AngularFirestoreModule,
    AngularFireStorageModule,
    TranslateSharedModule

  ],
  declarations: [
    UploadPluginComponent,
    ModalUploadPluginComponent,
    ModalMultiuploadPluginComponent
  ],
  exports: [
    UploadPluginComponent,
    ModalUploadPluginComponent,
    ModalMultiuploadPluginComponent
  ],
  entryComponents: [
    ModalUploadPluginComponent,
    ModalMultiuploadPluginComponent
  ]
})

export class UploadModule { }



// WEBPACK FOOTER //
// ./src/app/modules/shared/upload/upload.module.ts